/*    
<summary>
   This file is used to provide initial values or state to the User Data observables.
   Developer:Ashish Singh, Created Date: 29-August-2023
</summary>
*/

import { IHQStoreEmailSettings } from "../../models/response/IEmailManagementResponse";


export const initialState: IHQStoreEmailSettings = {
  Id: -1,
  HeadquarterId: -1,
  EmailBeforeHours: 0,
  EmailAfterHours: 0,
  EmailType: 0,
  EmailBody: "",
  EmailHeader: "",
  EmailFooter: "",
  StoreId: -1,
  StoreEmailBody: "",
  BeforeDays: 0,
  BeforeHours: 0,
  IsSend: false,
}